import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
// CountdownBar (fake urgency) and Testimonials (no real reviews yet) are intentionally not rendered.
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'en';
    document.title = 'Hockey Ready™ – Your Whole Field Hockey Season, Planned for You';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mkhofzsx1e8o">
      <div lang="en" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mj6ipufwtwex">
        <main data-id="element-2" data-mp="3recedkz46pg7">
          <Hero data-id="element-3" data-mp="5yk6vxnnffx" />
          <StatsBar data-id="element-4" data-mp="5opww5kum4f" />
          <Difference data-id="element-5" data-mp="4wv3njt0sf7" />
          <Recognize data-id="element-6" data-mp="5ggxfcks0yi" />
          <WhatsInside data-id="element-7" data-mp="7sulgbavp5r" />
          <InsidePages data-id="element-8" data-mp="2zld1r8m3ndb0" />
          <Bonuses data-id="element-9" data-mp="2zm4zaoz9bl3x" />
          <HowItWorks data-id="element-10" data-mp="2zmo6pbra6r3p" />
          <Audience data-id="element-11" data-mp="2zng1ikd20ksx" />
          <Offer data-id="element-12" data-mp="33mf2jtvnzxf3" />
          <Guarantee data-id="element-13" data-mp="33lwywc6oagx5" />
          <Faq data-id="element-14" data-mp="33ngfy505kvzz" />
          <FinalCta data-id="element-15" data-mp="33mykvbp88ntn" />
        </main>
        <Footer data-id="element-16" data-mp="38m1gy6n8bjph" />
      </div>
    </MotionConfig>;
}